import React from 'react';
import UpdateTechnical from './UpdateTechnical';


function EditTechnicalPage() {
    

    return (
        <div className="container-fluid">
           
            <UpdateTechnical/>
        </div>
    );
}

export default EditTechnicalPage;
